var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"tippy",rawName:"v-tippy"}],staticClass:"button is-size-7",class:[_vm.styles, { 'is-loading': _vm.waitKey ? _vm.$wait.is(_vm.waitKey) : false }],attrs:{"disabled":_vm.disabled,"title":_vm.tooltip},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }